import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const ArticleIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 21V1H19V20.8529"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        fill="none"
      />
      <path
        d="M19 20.8889L16.5 20L14 21L11.5 20.1111L9 21L6.5 20.1111L4 21"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        fill="none"
      />
      <path
        d="M14.8823 12.4706H8.11765"
        stroke={color}
        strokeLinecap="round"
        strokeWidth={1.5}
        fill="none"
        strokeLinejoin="round"
      />
      <path
        d="M14.8823 8.94117H8.11765"
        stroke={color}
        strokeLinecap="round"
        strokeWidth={1.5}
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  </CircledIcon>
);
